<template>
  <div class="yssq_dialog_inside">
    <!-- 经办人身份证  -->
    <el-dialog
      v-if="JBRdialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      title="经办人身份证"
      :visible.sync="JBRdialogVisible"
      width="960px"
    >
      <el-form ref="jbrForm" :model="jbrForm" label-width="80px">
        <el-form-item label-width="91px" label="经办人:" prop="jbrXm">
          <!-- :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'" -->
          <el-input v-model="jbrForm.jbrXm" disabled placeholder="" />
        </el-form-item>
        <el-form-item label-width="91px" label="身份证:" prop="jbrSfzh">
          <el-input
            v-model="jbrForm.jbrSfzh"
            disabled
            placeholder="请输入证件编号"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="手机号码:" prop="jbrSjh">
          <el-input
            v-model="jbrForm.jbrSjh"
            disabled
            placeholder="请输入"
          />
        </el-form-item>
        <el-form-item
          style="width: 100%"
          prop="images"
          :rules="{
            required: false,
            validator: fileValidator,
          }"
        >
          <div class="fujian required">
            上传附件（{{ jbrForm.fjList.length }}/6）(500KB以内)
          </div>
          <el-upload
            :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
            class="avatar-uploader"
            :headers="token"
            :action="returnSaveFile"
            :limit="6"
            :file-list="jbrFileList"
            :on-success="onSuccess"
            :on-remove="onRemove"
            :on-preview="handlePictureCardPreview"
            list-type="picture-card"
            :before-upload="beforeAvatarUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="buttonList">
        <el-button
          v-preventReClick
          @click="JBRdialogVisible = false"
        >取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
          @click="Queding('4')"
        >保 存</el-button>
      </div>
    </el-dialog>
    <!-- 营业执照 -->
    <el-dialog
      v-if="YYZZdialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="7.5vh"
      center
      title="营业执照"
      :visible.sync="YYZZdialogVisible"
      width="1136px"
    >
      <el-form ref="yyzzForm" :model="yyzzForm" label-width="100px" :rules="rules">
        <el-form-item
          label="名称:"
          prop="yyzzMc"
          :rules="{
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 200);
            },
            required: true,
            trigger: ['blur', 'change'],
          }"
        >
          <el-input
            v-model="yyzzForm.yyzzMc"
            :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
            style="width: 340px"
            placeholder="请输入"
          />
        </el-form-item>
        <el-form-item
          style="width: 475px"
          label-width="140px"
          label="统一社会信用代码:"
          prop="yyzzTyshxydm"
          :rules="{
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 100);
            },
            required: true,
            trigger: ['blur', 'change'],
          }"
        >
          <el-input
            v-model="yyzzForm.yyzzTyshxydm"
            :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
            style="width: 340px"
            placeholder="请输入"
          />
        </el-form-item>
        <el-form-item label="类型:" prop="yyzzLx" required>
          <el-select
              clearable
            v-model="yyzzForm.yyzzLx"
            :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
            style="width: 340px"
            placeholder=""
          >
            <el-option
              v-for="item in dwlxList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="法定代表人:"
          prop="yyzzFr"
          :rules="{
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 200);
            },
            trigger: ['blur', 'change'],
          }"
          required
        >
          <el-input
            v-model="yyzzForm.yyzzFr"
            :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
            style="width: 340px"
            placeholder="请输入"
          />
        </el-form-item>
        <el-form-item
          label="注册资本:"
          prop="yyzzZczb"
          :rules="{
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 100);
            },
            trigger: ['blur', 'change'],
          }"
          required
        >
          <div style="width: 340px">
            <el-input
              v-model="yyzzForm.yyzzZczb"
              :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
              style="width: 65%"
              placeholder="请输入"
            />
            <el-select
              v-model="yyzzForm.yyzzZczbdw"
              :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
              style="width: calc(35% - 10px); margin-left: 10px"
              placeholder="单位"
            >
              <el-option
                v-for="item in jgdaList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
        </el-form-item>
        <el-form-item
          label="发证机关:"
          prop="fzjg"
          :rules="{
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 255);
            },
            trigger: ['blur', 'change'],
          }"
          required
        >
          <el-input
            v-model="yyzzForm.fzjg"
            :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
            style="width: 340px"
            placeholder="请输入发证机关"
          />
        </el-form-item>
        <el-form-item label="营业期限:" required>
          <el-col :span="11">
            <el-form-item prop="yxqKs" >
              <el-date-picker
                v-model="yyzzForm.yxqKs"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
                style="width: 160px;"
              />
            </el-form-item>
          </el-col>
          <el-col class="line" style="text-align: center" :span="2">-</el-col>
          <el-col :span="11">
            <el-form-item prop="yxqJs">
              <el-date-picker
                v-model="yyzzForm.yxqJs"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions1"
                style="width: 160px;"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="成立日期:" prop="yyzzClrq">
          <el-date-picker
            v-model="yyzzForm.yyzzClrq"
            :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
            value-format="yyyy-MM-dd"
            style="width: 340px"
            type="date"
            placeholder="请选择日期"
          />
        </el-form-item>
        <el-form-item
          style="width: 100%"
          label="经营范围:"
          prop="yyzzJyfw"
          :rules="{
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 3000);
            },
            trigger: ['blur', 'change'],
          }"
          required
        >
          <el-input
            v-model="yyzzForm.yyzzJyfw"
            :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
            style="width: 100%"
            type="textarea"
            :rows="3"
            resize="none"
            placeholder="请输入经营范围"
          />
        </el-form-item>

        <el-form-item label="发证日期:" prop="fzrq">
          <el-date-picker
            v-model="yyzzForm.fzrq"
            :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="请输入发证日期"
            style="width: 340px"
          />
        </el-form-item>
      </el-form>
      <div class="fujian">
        上传附件（{{ yyzzForm.fjList.length }}/6）(500KB以内)
      </div>
      <el-upload
        :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
        class="avatar-uploader"
        :headers="token"
        :action="returnSaveFile"
        :limit="6"
        :file-list="yyzzFileList"
        :on-success="onSuccess"
        :on-remove="onRemove"
        list-type="picture-card"
        :on-preview="handlePictureCardPreview"
        :before-upload="beforeAvatarUpload"
      >
        <i class="el-icon-plus avatar-uploader-icon" />
      </el-upload>
      <div slot="footer" class="buttonList">
        <el-button
          v-preventReClick
          @click="YYZZdialogVisible = false"
        >取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
          @click="Queding('1','yyzzForm')"
        >保 存</el-button>
        <el-button
            v-preventReClick
            type="danger"
            :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
            @click="clearData('1','yyzzForm')"
        >清空并保存</el-button>
      </div>
    </el-dialog>
    <!-- 其他组织 -->
    <el-dialog
      v-if="QTZZdialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      title="其他组织的登记证书或者成立批准文件"
      :visible.sync="QTZZdialogVisible"
      width="1000px"
    >
      <el-form ref="qtzzForm" :model="qtzzForm" label-width="90px" :rules="rules">
        <el-form-item
          label="证书名称:"
          prop="qtzzZsmc"
          :rules="{
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 200);
            },
            trigger: ['blur', 'change'],
          }"
          required
        >
          <el-input
            v-model="qtzzForm.qtzzZsmc"
            :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
          />
        </el-form-item>
        <el-form-item
          label="证书编号:"
          prop="qtzzZsbh"
          :rules="{
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 100);
            },
            trigger: ['blur', 'change'],
          }"
          required
        >
          <el-input
            v-model="qtzzForm.qtzzZsbh"
            :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
          />
        </el-form-item>
        <el-form-item label="有效期:" required>
          <el-col :span="11">
            <el-form-item prop="yxqKs" >
              <el-date-picker
                  prop="yxqKs"
                v-model="qtzzForm.yxqKs"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                  style="width: 135px;"
              />
            </el-form-item>
          </el-col>
          <el-col class="line" style="text-align: center" :span="2">-</el-col>
          <el-col :span="11">
            <el-form-item prop="yxqJs">
              <el-date-picker
                v-model="qtzzForm.yxqJs"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
                style="width: 135px;"
                :picker-options="pickerOptions1"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item
          label="发证机关:"
          prop="fzjg"
          :rules="{
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 255);
            },
            trigger: ['blur', 'change'],
          }"
          required
        >
          <el-input
            v-model="qtzzForm.fzjg"
            :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
          />
        </el-form-item>
        <el-form-item label="发证日期:" prop="fzrq">
          <el-date-picker
            v-model="qtzzForm.fzrq"
            :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <div class="fujian">
        上传附件（{{ qtzzForm.fjList.length }}/6）(500KB以内)
      </div>
      <el-upload
        :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
        class="avatar-uploader"
        :headers="token"
        :action="returnSaveFile"
        :limit="6"
        :file-list="qtzzFileList"
        :on-success="onSuccess"
        :on-remove="onRemove"
        list-type="picture-card"
        :on-preview="handlePictureCardPreview"
        :before-upload="beforeAvatarUpload"
      >
        <i class="el-icon-plus avatar-uploader-icon" />
      </el-upload>
      <div slot="footer" class="buttonList">
        <el-button
          v-preventReClick
          @click="QTZZdialogVisible = false"
        >取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
          @click="Queding('2','qtzzForm')"
        >保 存</el-button>
        <el-button
            v-preventReClick
            type="danger"
            :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
            @click="clearData('2','qtzzForm')"
        >清空并保存</el-button>
      </div>
    </el-dialog>
    <!-- 购销合同 -->
    <el-dialog
      v-if="GXHTdialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      title="购销合同"
      :visible.sync="GXHTdialogVisible"
      width="1000px"
    >
      <el-form ref="gxhtForm" :model="gxhtForm" label-width="90px" :rules="rules">
        <el-form-item
          label="合同编号:"
          prop="gxhtHtbh"
          :rules="{
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 100);
            },
            trigger: ['blur', 'change'],
          }"
          required
        >
          <el-input
            v-model="gxhtForm.gxhtHtbh"
            :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
          />
        </el-form-item>
        <el-form-item
          label="甲方:"
          prop="gxhtJfm"
          :rules="{
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 200);
            },
            trigger: ['blur', 'change'],
          }"
          required
        >
          <el-input
            v-model="gxhtForm.gxhtJfm"
            :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
          />
        </el-form-item>
        <el-form-item
          label="乙方:"
          prop="gxhtYfm"
          :rules="{
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 200);
            },
            trigger: ['blur', 'change'],
          }"
          required
        >
          <el-input
            v-model="gxhtForm.gxhtYfm"
            :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
          />
        </el-form-item>
        <el-form-item label="化学品:" prop="gxhtHxp">
          <el-cascader
            ref="hxps"
            v-model="gxhtForm.gxhtHxp"
            style="width: 100%"
            placeholder="请选择化学品"
            :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
            :options="huaxuepinList"
            @change="handleChange"
          />
          <!-- <el-input   @change="handleChange"
            :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
            v-model="gxhtForm.gxhtHxp"
          ></el-input> -->
        </el-form-item>
        <!-- <el-form-item label="有效期:">
          <el-col :span="11">
            <el-date-picker
              :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
              value-format="yyyy-MM-dd"
              v-model="gxhtForm.yxqKs"
              type="date"
              placeholder="选择日期"
              style="width: 100%"
            ></el-date-picker>
          </el-col>
          <el-col class="line" style="text-align: center" :span="2">-</el-col>
          <el-col :span="11">
            <el-date-picker
              :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
              value-format="yyyy-MM-dd"
              v-model="gxhtForm.yxqJs"
              type="date"
              placeholder="选择日期"
              style="width: 100%"
            ></el-date-picker>
          </el-col>
        </el-form-item> -->
        <el-form-item label="签订日期:" prop="gxhtQdrq">
          <el-date-picker
            v-model="gxhtForm.gxhtQdrq"
            :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <div class="fujian">
        上传附件（{{ gxhtForm.fjList.length }}/6）(500KB以内)
      </div>
      <el-upload
        :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
        class="avatar-uploader"
        :headers="token"
        :action="returnSaveFile"
        :limit="6"
        :file-list="gxhtFileList"
        :on-success="onSuccess"
        :on-remove="onRemove"
        list-type="picture-card"
        :on-preview="handlePictureCardPreview"
        :before-upload="beforeAvatarUpload"
      >
        <i class="el-icon-plus avatar-uploader-icon" />
      </el-upload>
      <div slot="footer" class="buttonList">
        <el-button
          v-preventReClick
          @click="GXHTdialogVisible = false"
        >取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
          @click="Queding('6','gxhtForm')"
        >保 存</el-button>
      </div>
    </el-dialog>
    <!-- 货主身份证明 -->
    <el-dialog
      v-if="SFZMdialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      title="货主身份证明"
      :visible.sync="SFZMdialogVisible"
      width="960px"
    >
      <div class="fujian">
        上传附件（{{ sfzForm.fjList.length }}/6）(500KB以内)
      </div>
      <el-upload
        :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
        class="avatar-uploader"
        :headers="token"
        :action="returnSaveFile"
        :limit="6"
        :file-list="sfzmFileList"
        :on-success="onSuccess"
        :on-remove="onRemove"
        list-type="picture-card"
        :on-preview="handlePictureCardPreview"
        :before-upload="beforeAvatarUpload"
      >
        <i class="el-icon-plus avatar-uploader-icon" />
      </el-upload>
      <div slot="footer" class="buttonList">
        <el-button
          v-preventReClick
          @click="SFZMdialogVisible = false"
        >取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
          @click="Queding('5')"
        >保 存</el-button>
        <el-button
            v-preventReClick
            type="danger"
            :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
            @click="clearData('5')"
        >清空并保存</el-button>
      </div>
    </el-dialog>
    <!-- 其他证件 -->
    <el-dialog
      v-if="QTdialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      title="其他证件"
      :visible.sync="QTdialogVisible"
      width="1000px"
    >
      <el-form ref="qtzjForm" :model="qtzjForm" label-width="90px" :rules="rules">
        <el-form-item
          label="证书名称:"
          prop="qtzjZsmc"
          :rules="{
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 200);
            },
            trigger: ['blur', 'change'],
          }"
          required
        >
          <el-input
            v-model="qtzjForm.qtzjZsmc"
            :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
          />
        </el-form-item>
        <el-form-item
          label="证书编号:"
          prop="qtzjZsbh"
          :rules="{
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 100);
            },
            trigger: ['blur', 'change'],
          }"
          required
        >
          <el-input
            v-model="qtzjForm.qtzjZsbh"
            :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
          />
        </el-form-item>
        <el-form-item label="有效期:" required>
          <el-col :span="11">
            <el-form-item prop="yxqKs" >
              <el-date-picker
                  prop="yxqKs"
                v-model="qtzjForm.yxqKs"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
                  style="width: 135px;"
              />
            </el-form-item>
          </el-col>
          <el-col class="line" style="text-align: center" :span="2">-</el-col>
          <el-col :span="11">
            <el-form-item prop="yxqJs" >
              <el-date-picker
                  prop="yxqJs"
                v-model="qtzjForm.yxqJs"
                :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions1"
                  style="width: 135px;"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item
          label="发证机关:"
          prop="fzjg"
          :rules="{
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 255);
            },
            trigger: ['blur', 'change'],
          }"
          required
        >
          <el-input
            v-model="qtzjForm.fzjg"
            :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
          />
        </el-form-item>
        <el-form-item label="发证日期:" prop="fzrq">
          <el-date-picker
            v-model="qtzjForm.fzrq"
            :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <div class="fujian">
        上传附件（{{ qtzjForm.fjList.length }}/6）(500KB以内)
      </div>
      <el-upload
        :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
        class="avatar-uploader"
        :headers="token"
        :action="returnSaveFile"
        :limit="6"
        :file-list="qtzjFileList"
        :on-success="onSuccess"
        :on-remove="onRemove"
        list-type="picture-card"
        :on-preview="handlePictureCardPreview"
        :before-upload="beforeAvatarUpload"
      >
        <i class="el-icon-plus avatar-uploader-icon" />
      </el-upload>
      <div slot="footer" class="buttonList">
        <el-button
          v-preventReClick
          @click="QTdialogVisible = false"
        >取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
          @click="Queding('7','qtzjForm')"
        >保 存</el-button>
        <el-button
            v-preventReClick
            type="danger"
            :disabled="type == 'query' || type == 'qxhx' || type == 'xkzhx'"
            @click="clearData('7','qtzjForm')"
        >清空并保存</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      :visible.sync="dialogVisible"
      class="yulan"
    >
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
import {
  deletefile,
  getHxpCascader
} from '@/assets/js/yssq.js'
import { lengthValidate } from '@/assets/js/validate.js'
import { returnSaveFile,
  returnShowPic,
  getkv, getToken } from '@/assets/js/common'
export default {
  components: {},
  props: {
    type: String,
    gxhth: String
  },
  data() {
    return {
      dialogVisible: false,
      dialogImageUrl: '',
      huaxuepinList: [],
      pickerOptions: {
        disabledDate: (time) => {
          return time > Date.now()
        }
      },
      pickerOptions1: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          },
          {
            text: '永久日期',
            onClick(picker) {
              const date = new Date('2099-12-31')
              picker.$emit('pick', date)
            }
          }
        ]
      },
      removeImgIdList: [],
      token: {
        Authorization: getToken()
      },
      returnShowPic: '',
      returnSaveFile: '',
      JBRdialogVisible: false,
      YYZZdialogVisible: false,
      QTZZdialogVisible: false,
      GXHTdialogVisible: false,
      SFZMdialogVisible: false,
      QTdialogVisible: false,

      jbrFileList: [],
      yyzzFileList: [],
      qtzzFileList: [],
      gxhtFileList: [],
      sfzmFileList: [],
      qtzjFileList: [],
      dwlxList: [],
      jgdaList: [],
      FileList: [],
      flag: false,
      rules: {
        yyzzLx: [{ required: true, message: '请选择', trigger: ['blur', 'change']}],
        yyzzClrq: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
        fzrq: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
        yxqKs: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
        yxqJs: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
        gxhtQdrq: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
        gxhtHxp: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
      },
      gxhtForm: {
        gxhtHxp: '',
        gxhtHtbh: '',
        gxhtJfm: '',
        gxhtYfm: '',
        gxhtQdrq: '',
        zjlx: '6', // 证件类型
        yxqKs: '', // 有效期开始时间
        yxqJs: '', // 有效期结束时间
        fzrq: '', //  发证日期
        fzjg: '', // 发证机关
        fjList: []
      },
      qtzzForm: {
        // 其他组织
        qtzzZsmc: '',
        qtzzZsbh: '',
        qtzzZjnr: '',
        fzrq: '', //  发证日期
        fzjg: '', // 发证机关
        zjlx: '2', // 证件类型
        yxqKs: '', // 有效期开始时间
        yxqJs: '', // 有效期结束时间
        fjList: []
      },
      qtzjForm: {
        qtzjZsmc: '',
        qtzjZsbh: '',
        fzrq: '', //  发证日期
        fzjg: '', // 发证机关
        zjlx: '7', // 证件类型
        yxqKs: '', // 有效期开始时间
        yxqJs: '', // 有效期结束时间
        fjList: []
      },
      yyzzForm: {
        fzjg: '',
        yxqJs: '',
        yxqKs: '',
        yyzzClrq: '',
        yyzzFr: '',
        yyzzJyfw: '',
        yyzzLx: '',
        yyzzMc: '',
        yyzzTyshxydm: '',
        yyzzZczb: '',
        yyzzZczbdw: '',
        fzrq: '',
        yyzzZczbdwmc: '',
        zjlx: '1',
        fjList: []
      },
      jbrForm: {
        zjlx: '4',
        jbrSjh: '',
        jbrXm: '',
        jbrSfzh: '',
        fjList: []
      },
      sfzForm: {
        zjlx: '5',
        fjList: []
      }
    }
  },
  computed: {},
  watch: {
    'gxhtForm.fjList.length': {
      deep: true,
      handler(val) {
        // 页面加载完成后执行
        this.$nextTick(() => {
          if (val >= 6 || this.type == 'query' || this.type == 'qxhx' || this.type == 'xkzhx') {
            document.getElementsByClassName(
              'el-upload--picture-card'
            )[0].style.display = 'none'
          } else {
            document.getElementsByClassName(
              'el-upload--picture-card'
            )[0].style.display = 'inline-block'
          }
        })
      }
    },
    'jbrForm.fjList.length': {
      deep: true,
      handler(val) {
        // 页面加载完成后执行
        this.$nextTick(() => {
          if (val >= 6 || this.type == 'query' || this.type == 'qxhx' || this.type == 'xkzhx') {
            document.getElementsByClassName(
              'el-upload--picture-card'
            )[0].style.display = 'none'
          } else {
            document.getElementsByClassName(
              'el-upload--picture-card'
            )[0].style.display = 'inline-block'
          }
        })
      }
    },
    'qtzzForm.fjList.length': {
      deep: true,
      handler(val) {
        // 页面加载完成后执行
        this.$nextTick(() => {
          if (val >= 6 || this.type == 'query' || this.type == 'qxhx' || this.type == 'xkzhx') {
            document.getElementsByClassName(
              'el-upload--picture-card'
            )[0].style.display = 'none'
          } else {
            document.getElementsByClassName(
              'el-upload--picture-card'
            )[0].style.display = 'inline-block'
          }
        })
      }
    },
    'qtzjForm.fjList.length': {
      deep: true,
      handler(val) {
        // 页面加载完成后执行
        this.$nextTick(() => {
          if (val >= 6 || this.type == 'query' || this.type == 'qxhx' || this.type == 'xkzhx') {
            document.getElementsByClassName(
              'el-upload--picture-card'
            )[0].style.display = 'none'
          } else {
            document.getElementsByClassName(
              'el-upload--picture-card'
            )[0].style.display = 'inline-block'
          }
        })
      }
    },
    'yyzzForm.fjList.length': {
      deep: true,
      handler(val) {
        // 页面加载完成后执行
        this.$nextTick(() => {
          if (val >= 6 || this.type == 'query' || this.type == 'qxhx' || this.type == 'xkzhx') {
            document.getElementsByClassName(
              'el-upload--picture-card'
            )[0].style.display = 'none'
          } else {
            document.getElementsByClassName(
              'el-upload--picture-card'
            )[0].style.display = 'inline-block'
          }
        })
      }
    },
    'sfzForm.fjList.length': {
      deep: true,
      handler(val) {
        // 页面加载完成后执行
        this.$nextTick(() => {
          if (val >= 6 || this.type == 'query' || this.type == 'qxhx' || this.type == 'xkzhx') {
            document.getElementsByClassName(
              'el-upload--picture-card'
            )[0].style.display = 'none'
          } else {
            document.getElementsByClassName(
              'el-upload--picture-card'
            )[0].style.display = 'inline-block'
          }
        })
      }
    }
  },
  created() {
    // 获取文件上传地址
    this.returnSaveFile = returnSaveFile()
    // 获取文件回显地址
    this.returnShowPic = returnShowPic()
  },
  mounted() {
    // 获取证件类型
    getkv('xkz_zjlx').then((e) => { })
    // 获取单位类型
    getkv('yzd_dwlx').then((e) => {
      this.dwlxList = e.data.data
    })
    // 获取价格单位
    getkv('yzd_xkzdjdw').then((e) => {
      this.jgdaList = e.data.data
    })
    // 获取化学品信息
    this.$nextTick(() => {
      getHxpCascader().then((e) => {
        this.huaxuepinList = e.data.data
      })
    })
  },
  beforeDestroy() { },
  methods: {
    fileValidator(rule, value, callback) {
      // 附件校验
      if (!this.fileList || this.fileList.length === 0) {
        callback(new Error('附件必传!'))
      } else {
        if (this.fileList.some(d => d.status === 'uploading')) {
          callback(new Error('附件未上传完成，请稍后!'))
          return
        }
        callback()
      }
    },
    lengthValidate,
    // 点击文件列表中已上传的文件，预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    async Queding(type, formName) {
      if (formName) {
        let res1 = false;
        await this.$refs[formName].validate((valid) => {
          res1 = valid
        })
        if(!res1){
          return
        }
      }
      switch (type) {
        case '4':
          if (this.jbrForm.fjList == 0) {
            this.$message.error('请上传附件')
            return false
          }
          this.$parent.formData.xkzYsFjxxList[0] = this.jbrForm
          this.JBRdialogVisible = false
          break
        case '1':
          if (this.yyzzForm.fjList == 0) {
            this.$message.error('请上传附件')
            return false
          }
          this.$parent.formData.xkzYsFjxxList[1] = this.yyzzForm
          this.YYZZdialogVisible = false
          break
        case '2':
          if (this.qtzzForm.fjList == 0) {
            this.$message.error('请上传附件')
            return false
          }
          this.$parent.formData.xkzYsFjxxList[2] = this.qtzzForm
          this.QTZZdialogVisible = false
          break
        case '6':
          if (this.gxhtForm.fjList == 0) {
            this.$message.error('请上传附件')
            return false
          }
          const errorList = this.gxhtForm.fjList.filter(i => !i.wjdz || !i.zjlx)
          if (errorList.length > 0) {
            this.$message.error('请上传附件')
            return false
          }
          this.$parent.formData.xkzYsFjxxList[5] = this.gxhtForm
          this.GXHTdialogVisible = false
          break
        case '5':
          if (this.sfzForm.fjList == 0) {
            this.$message.error('请上传附件')
            return false
          }
          this.$parent.formData.xkzYsFjxxList[3] = this.sfzForm
          this.SFZMdialogVisible = false
          break
        case '7':
          if (this.qtzjForm.fjList == 0) {
            this.$message.error('请上传附件')
            return false
          }
          this.$parent.formData.xkzYsFjxxList[4] = this.qtzjForm
          this.QTdialogVisible = false
          break
        default:
          break
      }
      this.$parent.imgChange()
    },
    clearData(type){
      let tsxx = "<span style='color:red'>一旦清空，若再有需要则只能全部重新填写</span>，是否确定清空该证件模块的所有信息（包括图片)?"
      this.$confirm(tsxx, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(() => {
        switch (type) {
          case '1':
            this.$parent.formData.xkzYsFjxxList[1] = {}
            this.YYZZdialogVisible = false
            break
          case '2':
            this.$parent.formData.xkzYsFjxxList[2] = {}
            this.QTZZdialogVisible = false
            break
          case '5':
            this.$parent.formData.xkzYsFjxxList[3] = {}
            this.SFZMdialogVisible = false
            break
          case '7':
            this.$parent.formData.xkzYsFjxxList[4] = {}
            this.QTdialogVisible = false
            break
          default:
            break
        }
        this.$parent.imgChange()
      })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
    },
    // 根据父组件传来数据证件类型，判断给那个证件数据赋值
    FileDataShow(data) {
      const newData = JSON.parse(JSON.stringify(data))

      if (newData.zjlx == '4') {
        // 经办人身份证明
        this.jbrForm = newData
        this.jbrFileList = []
        newData.fjList.forEach((e) => {
          this.jbrFileList.push({
            id: e.id,
            url: this.returnShowPic + e.wjdz
          })
        })
      } else if (newData.zjlx == '1') {
        // 营业执照
        this.yyzzForm = newData
        this.yyzzFileList = []

        newData.fjList.forEach((e) => {
          this.yyzzFileList.push({
            id: e.id,
            url: this.returnShowPic + e.wjdz
          })
        })
      } else if (newData.zjlx == '2') {
        // 其他组织
        this.qtzzForm = newData
        this.qtzzFileList = []
        // 组装附件回显数据

        newData.fjList.forEach((e) => {
          this.qtzzFileList.push({
            id: e.id,
            url: this.returnShowPic + e.wjdz
          })
        })
      } else if (newData.zjlx == '6') {
        // 购销合同
        this.gxhtForm = Object.assign(
          {},
          {
            gxhtHxp: newData.gxhtHxp || '',
            gxhtHtbh: newData.gxhtHtbh || '',
            gxhtJfm: newData.gxhtJfm || '',
            gxhtYfm: newData.gxhtYfm || '',
            gxhtQdrq: newData.gxhtQdrq,
            zjlx: '6', // 证件类型
            fjList: newData.fjList
          }
        )
        // this.gxhtForm = newData;
        this.gxhtFileList = []
        // 组装附件回显数据
        newData.fjList.forEach((e) => {
          this.gxhtFileList.push({
            id: e.id,
            url: this.returnShowPic + e.wjdz
          })
        })
      } else if (newData.zjlx == '5') {
        // 货主身份证明
        this.sfzForm = newData
        this.sfzmFileList = []
        // 组装附件回显数据
        newData.fjList.forEach((e) => {
          this.sfzmFileList.push({
            id: e.id,
            url: this.returnShowPic + e.wjdz
          })
        })
      } else if (newData.zjlx == '7') {
        // 其他证件
        this.qtzjForm = newData
        this.qtzjFileList = []
        // 组装附件回显数据
        newData.fjList.forEach((e) => {
          this.qtzjFileList.push({
            id: e.id,
            url: this.returnShowPic + e.wjdz
          })
        })
      }
    },
    handleChange(value) {
      if (value == undefined) return
      this.gxhtForm.gxhtHxp = value.slice(-1).toString()
      // this.formData.hxpMc = this.$refs.hxps.getCheckedNodes()[0].data.label;
    },
    // 上传成功后
    onSuccess(response, file, fileList) {
      if (
        this.JBRdialogVisible &&
        file.status == 'success' &&
        this.jbrForm.fjList
      ) {
        this.jbrForm.fjList.push({ wjdz: response.data.url, zjlx: '4' })
      } else if (
        this.YYZZdialogVisible &&
        file.status == 'success' &&
        this.yyzzForm.fjList
      ) {
        this.yyzzForm.fjList.push({ wjdz: response.data.url, zjlx: '1' })
      } else if (
        this.GXHTdialogVisible &&
        file.status == 'success' &&
        this.gxhtForm.fjList
      ) {
        this.gxhtForm.fjList.push({ wjdz: response.data.url, zjlx: '6' })
      } else if (
        this.QTZZdialogVisible &&
        file.status == 'success' &&
        this.qtzzForm.fjList
      ) {
        this.qtzzForm.fjList.push({ wjdz: response.data.url, zjlx: '2' })
      } else if (
        this.QTdialogVisible &&
        file.status == 'success' &&
        this.qtzjForm.fjList
      ) {
        this.qtzjForm.fjList.push({ wjdz: response.data.url, zjlx: '7' })
      } else if (
        this.SFZMdialogVisible &&
        file.status == 'success' &&
        this.sfzForm.fjList
      ) {
        this.sfzForm.fjList.push({ wjdz: response.data.url, zjlx: '5' })
      }
    },
    // 删除存储的照片
    RemoveImgById() {
      if (this.removeImgIdList.length == 0) return
      this.removeImgIdList.forEach((e) => {
        deletefile(e).then(() => { })
      })
    },
    beforeAvatarUpload(file) {
      const fileType = ['image/jpeg', 'image/png', 'image/bmp', 'image/jpg']
      const isJPG = fileType.includes(file.type)

      const isLt = file.size / 1024 < 500
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/BMP/JPEG/PNG格式!')
      }
      if (!isLt) {
        this.$message.error('上传图片大小不能超过 500kb!')
      }
      return isJPG && isLt
    },
    // 文件删除时
    onRemove(file, fileList) {
      // this.removeImgIdList.push(file.id);
      if (file.id) {
        if (this.JBRdialogVisible) {
          this.jbrForm.fjList.filter((e, index) => {
            if (e.id == file.id) {
              this.jbrForm.fjList.splice(index, 1)
            }
            return this.jbrForm.fjList
          })
        }
        if (this.YYZZdialogVisible) {
          this.yyzzForm.fjList.filter((e, index) => {
            if (e.id == file.id) {
              this.yyzzForm.fjList.splice(index, 1)
            }
            return this.yyzzForm.fjList
          })
        }
        if (this.QTZZdialogVisible) {
          this.qtzzForm.fjList.filter((e, index) => {
            if (e.id == file.id) {
              this.qtzzForm.fjList.splice(index, 1)
            }
            return this.qtzzForm.fjList
          })
        }
        if (this.GXHTdialogVisible) {
          this.gxhtForm.fjList.filter((e, index) => {
            if (e.id == file.id) {
              this.gxhtForm.fjList.splice(index, 1)
            }
            return this.gxhtForm.fjList
          })
        }
        if (this.QTdialogVisible) {
          this.qtzjForm.fjList.filter((e, index) => {
            if (e.id == file.id) {
              this.qtzjForm.fjList.splice(index, 1)
            }
            return this.qtzjForm.fjList
          })
        }
        if (this.SFZMdialogVisible) {
          this.sfzForm.fjList.filter((e, index) => {
            if (e.id == file.id) {
              this.sfzForm.fjList.splice(index, 1)
            }
            return this.sfzForm.fjList
          })
        }
        deletefile(file.id).then((e) => {
          console.log(e.data)
        })
      } else {
        if (this.JBRdialogVisible) {
          if (file.url.includes(this.returnShowPic)) {
            this.jbrForm.fjList.filter((item, index) => {
              if (item.wjdz == file.url.split('=')[1]) { this.jbrForm.fjList.splice(index, 1) }
              return
            })
          } else if (file.response) {
            this.jbrForm.fjList.filter((item, index) => {
              if (item.wjdz == file.response.data.url) { this.jbrForm.fjList.splice(index, 1) }
              return
            })
          }
        }
        if (this.YYZZdialogVisible) {
          if (file.url.includes(this.returnShowPic)) {
            this.yyzzForm.fjList.filter((item, index) => {
              if (item.wjdz == file.url.split('=')[1]) { this.yyzzForm.fjList.splice(index, 1) }
              return
            })
          } else if (file.response) {
            this.yyzzForm.fjList.filter((item, index) => {
              if (item.wjdz == file.response.data.url) { this.yyzzForm.fjList.splice(index, 1) }
              return
            })
          }
        }
        if (this.QTZZdialogVisible) {
          if (file.url.includes(this.returnShowPic)) {
            this.qtzzForm.fjList.filter((item, index) => {
              if (item.wjdz == file.url.split('=')[1]) { this.qtzzForm.fjList.splice(index, 1) }
              return
            })
          } else if (file.response) {
            this.qtzzForm.fjList.filter((item, index) => {
              if (item.wjdz == file.response.data.url) { this.qtzzForm.fjList.splice(index, 1) }
              return
            })
          }
        }
        if (this.GXHTdialogVisible) {
          if (file.url.includes(this.returnShowPic)) {
            this.gxhtForm.fjList.filter((item, index) => {
              if (item.wjdz == file.url.split('=')[1]) { this.gxhtForm.fjList.splice(index, 1) }
              return
            })
          } else if (file.response) {
            this.gxhtForm.fjList.filter((item, index) => {
              if (item.wjdz == file.response.data.url) { this.gxhtForm.fjList.splice(index, 1) }
              return
            })
          }
        }
        if (this.QTdialogVisible) {
          if (file.url.includes(this.returnShowPic)) {
            this.qtzjForm.fjList.filter((item, index) => {
              if (item.wjdz == file.url.split('=')[1]) { this.qtzjForm.fjList.splice(index, 1) }
              return
            })
          } else if (file.response) {
            this.qtzjForm.fjList.filter((item, index) => {
              if (item.wjdz == file.response.data.url) { this.qtzjForm.fjList.splice(index, 1) }
              return
            })
          }
        }
        if (this.SFZMdialogVisible) {
          if (file.url.includes(this.returnShowPic)) {
            this.sfzForm.fjList.filter((item, index) => {
              if (item.wjdz == file.url.split('=')[1]) { this.sfzForm.fjList.splice(index, 1) }
              return
            })
          } else if (file.response) {
            this.sfzForm.fjList.filter((item, index) => {
              if (item.wjdz == file.response.data.url) { this.sfzForm.fjList.splice(index, 1) }
              return
            })
          }
        }
      }
    }
  }
}
</script>
<style scoped lang='less'>
/deep/.el-dialog--center .el-dialog__body {
  text-align: initial;
  padding: 25px 25px 30px;
  width: 85%;
  margin: auto;
}
.yssq_dialog_inside {
  .el-form {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .el-form-item {
      width: 47%;
    }
  }

  .buttonList {
    display: flex;
    justify-content: space-evenly;

    .el-button:nth-child(1) {
      color: #333333;
      width: 148px;
      height: 60px;
      background: #ebebeb;

      border: none;
    }
    .el-button:nth-child(2) {
      color: #ffffff;
      width: 148px;
      height: 60px;
      background: #4170ff;

      border: none;
    }
  }
}
/deep/.avatar-uploader .el-upload {
  border: 0 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader {
  height: 96px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
/deep/.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 96px !important;
  height: 96px !important;
  line-height: 96px !important;
  text-align: center;
  background: #f3f3f3;
  border-radius: 3px;
}
/deep/.el-upload {
  line-height: 96px !important;
}
.avatar {
  display: block;
}
/deep/.el-upload-list--picture-card .el-upload-list__item,
/deep/.el-upload--picture-card {
  width: 96px !important;
  height: 96px !important;
}

/deep/.el-upload-list__item {
  transition: none !important;
}
</style>
